<div *ngIf="!isMobile" class="p-grid marginzero">
  <div *ngFor="let item of localArrangerList; let i = index" class="arangerCard">
    <mat-accordion>
      <mat-expansion-panel
        hideToggle="true"
        #panel
        (mouseenter)="togglePanelhandler(i, panel)"
        (mouseleave)="togglePanelhandler(i, panel)"
        (click)="togglePanelhandler(i, panel)"
        [ngClass]="{'panelOpened': item.opened, 'panelClosed': !item.opened}" >
        <mat-expansion-panel-header style="cursor: default;">
          <mat-panel-title class="title">
            <p *ngIf="item.notescount > 0" (click)="goToSearch(item.id)" style="cursor: pointer; margin: 0">{{item.user_details?.name + ' ' + item.user_details?.surname}}</p>
            <p *ngIf="item.notescount === 0" style="cursor: default; margin: 0">{{item.user_details?.name + ' ' + item.user_details?.surname}}</p>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <div *ngIf="item.opened" class="panel">
          <img *ngIf="item.imagePath" [src]="item.imagePath" alt="avatar" class="avatar" [ngClass]="{'fadeIn': item.showImage}" />
          <img *ngIf="!item.imagePath" src="assets/arranger_empty.jpg" alt="avatar" class="avatar" [ngClass]="{'fadeIn': item.showImage}" />

          <p>{{ 'added_notes_count' | translate }} {{item.notescount}}</p>
          <p *ngIf="item.notescount > 0" (click)="goToSearch(item.id)" style="cursor: pointer">{{ 'see_notes' | translate }}</p>
          <p *ngIf="item.description">{{item.description}}</p>
        </div>

        <div *ngIf="!item.opened"  class="panel" style="color: transparent;">
          <p>{{ 'added_notes_count' | translate }} {{item.notescount}}</p>
          <p *ngIf="item.notescount > 0" (click)="goToSearch(item.id)" style="cursor: pointer">{{ 'see_notes' | translate }}</p>
          <p *ngIf="item.description">{{item.description}}</p>
        </div>

      </mat-expansion-panel>
    </mat-accordion>
  </div>
</div>

<div *ngIf="isMobile" class="p-grid marginzero">
  <div
    *ngFor="let item of localArrangerList; let i = index"
    (click)="togglePanelhandler(i)"
    class="arangerCard">
    <div [ngClass]="{'panelOpened': item.opened, 'panelClosed': !item.opened}" class="mobilePanel">
      <div class="title">
        <p style="margin: 0">{{item.user_details?.name + ' ' + item.user_details?.surname}}</p>
      </div>

      <div *ngIf="item.opened" class="panel">
        <img *ngIf="item.imagePath" [src]="item.imagePath" alt="avatar" class="avatar" [ngClass]="{'fadeIn': item.showImage}" />
        <img *ngIf="!item.imagePath" src="assets/arranger_empty.jpg" alt="avatar" class="avatar" [ngClass]="{'fadeIn': item.showImage}" />

        <p>{{ 'added_notes_count' | translate }} {{item.notescount}}</p>
        <p *ngIf="item.notescount > 0" (click)="goToSearch(item.id)" style="cursor: pointer">{{ 'see_notes' | translate }}</p>
        <p *ngIf="item.description">{{item.description}}</p>
      </div>

      <!-- <div *ngIf="!item.opened"  class="panel" style="color: transparent;">
        <p>{{ 'added_notes_count' | translate }} {{item.notescount}}</p>
        <p *ngIf="item.notescount > 0" (click)="goToSearch(item.id)" style="cursor: pointer">{{ 'see_notes' | translate }}</p>
        <p *ngIf="item.description">{{item.description}}</p>
      </div> -->
    </div>
  </div>
</div>
